/* eslint object-property-newline: 0 */
import mutations from './mutations';

const state = {
  logo: '/static/logo.png',
  colours: [
    {
      name: 'action',
      h: '0', s: '0%', l: '0%',
    },
    {
      name: 'action-secondary',
      h: '340', s: '50%', l: '85%',
    },
    {
      name: 'action-text',
      h: '150', s: '40%', l: '95%',
    },
    {
      name: 'action-secondary-text',
      h: '210', s: '40%', l: '20%',
    },
    {
      name: 'highlight',
      h: '0', s: '0%', l: '98%',
    },
    {
      name: 'branding',
      h: '0', s: '0%', l: '0%',
    },
    {
      name: 'text',
      h: '0', s: '0%', l: '60%',
    },
    {
      name: 'text-dark',
      h: '0', s: '0%', l: '40%',
    },
    {
      name: 'text-light',
      h: '0', s: '0%', l: '80%',
    },
    {
      name: 'text-hint',
      h: '0', s: '0%', l: '60%',
    },
    {
      name: 'favourite',
      h: '50', s: '90%', l: '50%',
    },
    {
      name: 'favourite-text',
      h: '50', s: '90%', l: '30%',
    },
    {
      name: 'background',
      h: '0', s: '0%', l: '97%',
    },
    {
      name: 'background-secondary',
      h: '0', s: '0%', l: '98%',
    },
    {
      name: 'dividers',
      h: '0', s: '0%', l: '95%',
    },
    {
      name: 'unit-sold',
      h: '0', s: '0%', l: '95%',
    },
    {
      name: 'availability-filtered',
      h: '180', s: '50%', l: '78%',
    },
    {
      name: 'availability-floorplan',
      h: '180', s: '64%', l: '55%',
    },
    {
      name: 'availability-unit',
      h: '180', s: '100%', l: '31%',
    }
  ]
};

export default {
  namespaced: true,
  state,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/project/theme/index.js